import { Navigate, Outlet } from "react-router-dom";
import AppNavigation from "@/components/navigation/AppNavigation";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthenticatedLayout() {
  const { session, loading } = useAuth();
  const user = session?.user ?? null;

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0b0d18] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <ThemeProvider>
      <div className="min-h-screen w-full flex flex-col">
        <main className="flex-1 overflow-auto pb-24 md:pb-16">
          <Outlet />
        </main>
        <AppNavigation />
      </div>
    </ThemeProvider>
  );
}
